import React, { Component } from 'react';

import {
    InputNumber,
    Radio,
    Input,
    Button,
    Modal,
} from 'antd';

class ModifyFibersModal extends Component {
    state = {
        fiberText: this.props.fiberText,
        endRadio: this.props.endRadio,
        fiberValue: this.props.fiberValue,
        fieldChoice: this.props.fieldChoice,
        fibers: this.props.fibers
    };

    close = () => {
       this.props.close();
    }

    /*
        Updates output fields with 'filter' (a, b, ab) and 'range' (comma separated or ranges of indices).
    */
    updateFiber = (filter, range, value, toUpdate) => {
        const parts = range.split(/[,\s]+/);
        if(filter !== 'ab' || range !== '') {
            toUpdate.forEach((_, index) => {
                for(let part of parts) {
                    const currIndexValue = this.state.fibers[index].includes('a') ? this.state.fibers[index].split('a')[0] : this.state.fibers[index].split('b')[0];
                    if(part.includes('-')) {
                        const [start, end] = part.split('-').map(Number);
                        if(currIndexValue >= start && currIndexValue <= end && (filter === 'ab' || this.state.fibers[index].includes(filter))) {
                            toUpdate[index] = value;
                        }
                    } else {
                        if((part === '' || part === currIndexValue) && (filter === 'ab' || this.state.fibers[index].includes(filter))) {
                            toUpdate[index] = value;
                        }
                    }
                }
            })
        } else {
            toUpdate.fill(value);
        }
        return toUpdate
    };

    render() {
        return(
            <Modal
                title="Modify Fibers"
                open={this.props.isOpen}
                onCancel={this.close}
                footer={[
                    <Button key="submit" onClick={() => {
                        this.props.update((state) => {
                            switch(this.state.fieldChoice) {
                                case("switch0"):
                                    let switch0 = [...state.switch0];
                                    switch0 = this.updateFiber(this.state.endRadio, this.state.fiberText, this.state.fiberValue, switch0)
                                    return { switch0 };
                                case("switch1"):
                                    let switch1 = [...state.switch1];
                                    switch1 = this.updateFiber(this.state.endRadio, this.state.fiberText, this.state.fiberValue, switch1)
                                    return { switch1 };
                                case("switch2"):
                                    let switch2 = [...state.switch2];
                                    switch2 = this.updateFiber(this.state.endRadio, this.state.fiberText, this.state.fiberValue, switch2)
                                    return { switch2 };
                                case("detector"):
                                    let detectors = [...state.detectors];
                                    detectors = this.updateFiber(this.state.endRadio, this.state.fiberText, this.state.fiberValue, detectors)
                                    return { detectors };
                                default:
                                    return state;
                            }
                        });
                    }}>
                        Apply
                    </Button>
                ]}
                >
                <div>Field: &nbsp;</div>
                <Radio.Group
                        buttonStyle="solid"
                        defaultValue={this.state.fieldChoice}
                        name="fieldChoiceGroup"
                        onChange={(e) => this.setState({ fieldChoice: e.target.value })}
                    >
                    <Radio.Button className="fibers-radio-buttons" value="switch0">Output</Radio.Button>
                    {this.props.useSwitch1 && (<Radio.Button className="fibers-radio-buttons" value="switch1">Switch #1</Radio.Button>)}
                    {this.props.useSwitch2 && (<Radio.Button className="fibers-radio-buttons" value="switch2">Switch #2</Radio.Button>)}
                    {this.props.showDetectors && (<Radio.Button className="fibers-radio-buttons" value="detector">Detector</Radio.Button>)}
                </Radio.Group>
                <div>Value: &nbsp;</div>
                <InputNumber
                    defaultValue={this.state.fiberValue}
                    onChange={(e) => this.setState({ fiberValue: e })}
                />{' '}
                <div>End: &nbsp;</div>
                <Radio.Group
                        buttonStyle="solid"
                        defaultValue={this.state.endRadio}
                        onChange={(e) => this.setState({ endRadio: e.target.value })}
                    >
                    <Radio.Button className="fibers-radio-buttons" value="a">a</Radio.Button>
                    <Radio.Button className="fibers-radio-buttons" value="b">b</Radio.Button>
                    <Radio.Button className="fibers-radio-buttons" value="ab">a/b</Radio.Button>
                </Radio.Group>
                <div> Fibers: &nbsp; </div>
                <Input
                    maxLength={15}
                    defaultValue={this.state.fiberText}
                    placeholder="1-6, 13, 15-18"
                    onChange={(e) => this.setState({ fiberText: e.target.value })}
                    >
                </Input>
            </Modal>
        );
    }
}

export default ModifyFibersModal;